var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-screen"},[_c('VersionSwitcher'),_c('TheNavbar',{attrs:{"fixed":""}}),_c('div',{staticClass:"flex-1 pt-12"},[_c('Nuxt')],1),_c('TheFooter'),_c('CookieInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }